import React, {useEffect, useMemo, useRef, useState} from 'react';
import {toast, ToastContainer} from "react-toastify";
import SideBar from "../../../common/SideBar";
import NavBar from "../../../common/NavBar";
import {Link} from "react-router-dom";
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from 'primereact/button';
import {FilterMatchMode, FilterOperator} from "primereact/api";
import {Tooltip} from 'primereact/tooltip';
import Spinner from "reactjs-simple-spinner";
import ReportsServices from "../../../services/ReportsServices";
import PoliciesPartial from "./partials/PoliciesPartial";
import DependentsPartial from "./partials/DependentsPartial";



const PolicyHoldersReport = (props) => {


    const PolicyHoldersReportColumns = useMemo(
        () => [
            {
                header: 'ID',
                field: 'id',
            },
            {
                header: 'Title',
                field: 'title',
            },
            {
                header: 'Firstname',
                field: 'first_name',
            },
            {
                header: 'Surname',
                field: 'last_name',
            },
            {
                header: 'ID Number',
                field: 'id_number',
            },
            {
                header: 'Date Of Birth',
                field: 'last_name',
            },
            {
                header: 'Gender',
                field: 'gender',
            },
            {
                header: 'Status',
                field: 'status',
            },
            {
                header: 'Email',
                field: 'email',
            },
            {
                header: 'Contact Number',
                field: 'mobile',
            },
            {
                header: 'Occupation',
                field: 'occupation',
            },
            {
                header: 'EC Number',
                field: 'ec_number',
            },
            {
                header: 'Salary',
                field: 'salary',
            },
            {
                header: 'Smoker Status',
                field: 'smoker_status',
            },
            {
                header: 'Joined',
                field: 'created_at',
            },
        ],
        []
    )

    const [data, setData] = useState([])
    const [policies, setPolicies] = useState([])
    const [dependents, setDependents] = useState([])

    const [selectedData, setSelectedData] = useState([])
    const dt = useRef(null);

    const exportColumns = PolicyHoldersReportColumns.map(col => ({title: col.header, dataKey: col.field}));

    const exportCSV = (selectionOnly) => {
        dt.current.exportCSV({selectionOnly});
    }

    const exportPdf = () => {
        import('jspdf').then(jsPDF => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default('l', "mm");
                doc.autoTable({
                    showHead: 'firstPage',
                    columns: exportColumns,
                    body: data,
                    styles: {overflow: 'linebreak', columnWidth: 'wrap', cellPadding: 1, fontsize: 6},
                    columnStyles: {
                        0: {columnWidth: 20},
                        1: {columnWidth: 20},
                        2: {columnWidth: 20},
                        3: {columnWidth: 20},
                        6: {columnWidth: 20},
                        7: {columnWidth: 22},
                        9: {columnWidth: 20}
                    }
                });
                doc.save('policy_holders_' + new Date().getDate() + '_' + new Date().getMonth() + '_' + new Date().getFullYear() + '.pdf');
            })
        })
    }


    const exportExcel = () => {
        import('xlsx').then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(data);
            const workbook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
            const excelBuffer = xlsx.write(workbook, {bookType: 'xlsx', type: 'array'});
            saveAsExcelFile(excelBuffer, 'policy_holders_' + new Date().getDate() + '_' + new Date().getMonth() + '_' + new Date().getFullYear());
        });
    }

    const saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then(module => {
            if (module && module.default) {
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE
                });

                module.default.saveAs(data, fileName + '_export_' + new Date().getDate() + '_' + new Date().getMonth() + '_' + new Date().getFullYear() + EXCEL_EXTENSION);
            }
        });
    }

    const onSelectionChange = (e) => {
        setSelectedData(e.value);
    }

    const [request, setRequest] = useState({id_number: '', mobile_number: ''});
    const [loading, setLoading] = useState(false);

    const handleOnChangeId = name => ({target: {value}}) => {
        console.log("id: ", value);
        setRequest({...request, [name]: value});
    }

    const handleOnChangeMobile = name => ({target: {value}}) => {
        console.log("mobile: ", name);
        setRequest({...request, [name]: value});
    }

    const [choice, setChoice] = useState('choice1')

    const handleOnChangeChoice = (e) => {
        console.log(e.target.value)
        setChoice(e.target.value)
        if (e.target.value === 'choice1') {
            setRequest({...request, mobile_number: ''})
        } else {
            setRequest({...request, id_number: ''})
        }

    }

    const handleSubmit = () => {
        setLoading(true)
        if (request.id_number === '' && request.mobile_number === '') {
            setLoading(false)
            toast.error('Please enter valid inputs!!', {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
            });
            return
        }
        console.log("request: ", request)
        ReportsServices.leadsData(request)
            .then(res => {
                console.log("success: ", res.data);
                if (res.status === 200) {
                    setData([res.data.policy_holder])
                    setPolicies(res.data.policies)
                    setDependents(res.data.dependents);
                    setRequest({id_number: '', mobile_number: ''})
                    setLoading(false)
                } else {
                    setData([])
                    setDependents([])
                    setPolicies([])
                    setLoading(false)
                }
            }).catch(err => {
            console.log("error: ", err)
            setData([])
            setDependents([])
            setPolicies([])
            setLoading(false)
        })
    }

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        setLoading(false);
        setRequest({id_number: '', mobile_number: ''})
        setData([])
        setDependents([])
        setPolicies([])

    }, []);






    const header = (
        <div className="flex align-items-center export-buttons">
            <Button type="button" icon="pi pi-file" onClick={() => exportCSV(false)}
                    className="mr-2 p-button-secondary p-button-sm" data-pr-tooltip="CSV"/>
            <Button type="button" icon="pi pi-file-excel" onClick={exportExcel}
                    className="p-button-dark mr-2 p-button-sm" data-pr-tooltip="XLS"/>
            <Button type="button" icon="pi pi-file-pdf" onClick={exportPdf} className="p-button-danger mr-2 p-button-sm"
                    data-pr-tooltip="PDF"/>
            <Button type="button" icon="pi pi-filter" onClick={() => exportCSV(true)}
                    className="p-button-info ml-auto p-button-sm" data-pr-tooltip="Export Selection Only"/>
        </div>
    );

    // const footer = `In total there are ${data ? data.length : 0} commissions.`;

    /**
     *  Filter Modes
     */


    const filters = {
            'agent_name': {
                operator: FilterOperator.OR,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'agent_surname': {
                operator: FilterOperator.OR,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'policy_number': {
                operator: FilterOperator.OR,
                constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
            },
            'next_invoicing_date': {
                operator: FilterOperator.OR,
                constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
            },
            'currency': {
                operator: FilterOperator.OR,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'policy_holder.first_name': {
                operator: FilterOperator.OR,
                constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
            },
            'policy_holder.last_name': {
                operator: FilterOperator.OR,
                constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
            },
            'manager': {
                operator: FilterOperator.OR,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'commencement_date': {
                operator: FilterOperator.OR,
                constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
            },

        }


    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <div id="main-content" className="main-panel ps-container ps-theme-default">
                <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                <div className="content">
                    <div className="container-fluid">
                        <ul className="breadcrumb">
                            <Link to="/dashboard"><a href><i className="fa fa-home"/>&nbsp;Dashboard</a> </Link>
                            &nbsp;|&nbsp;
                            <Link to="/reports"><a href><i className="fa fa-folder-tree"/>&nbsp;Reports</a> </Link>
                            &nbsp;|&nbsp;
                           Policy Holders
                        </ul>
                        {loading && (
                            <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                <Spinner
                                    size="medium"
                                    message="Please wait....."
                                    line-fg-color="#64c3c2"
                                />
                            </div>

                        )}
                        {!loading && (
                            <div className="row mt">

                                <div className="col-lg-12">

                                    {/*    tabs*/}
                                    <div className="card p-2">
                                        <h5 className="title h3 px-4">Policy Holder</h5>
                                        <div className="row px-4 container-fluid mt-2 mb-2">
                                            <div className="col-md-3">
                                                <label htmlFor="">Holder's Id Number:</label>
                                                <input type="text" className="form-control" name="id_number"
                                                       value={request.id_number}
                                                       onChange={handleOnChangeId('id_number')}
                                                       disabled={choice === 'choice2'}
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group container">
                                                    <input type="radio" name="choice" value="choice1" className=""
                                                           onChange={handleOnChangeChoice}
                                                           checked={choice === 'choice1'}
                                                    />
                                                    <span className="p-2">Select One</span>
                                                    <input type="radio" name="choice" value="choice2" className=""
                                                           onChange={handleOnChangeChoice}
                                                           checked={choice === 'choice2'}
                                                    />
                                                </div>

                                            </div>
                                            <div className="col-md-3">
                                                <label htmlFor="">Holder's Mobile:</label>
                                                <input type="tel" className="form-control" name="mobile_number"
                                                       value={request.mobile_number}
                                                       onChange={handleOnChangeMobile('mobile_number')}
                                                       disabled={choice === 'choice1'}
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <label htmlFor=""></label>
                                                <button onClick={handleSubmit}
                                                        className="btn btn-primary btn-sm">Search
                                                </button>
                                            </div>
                                        </div>
                                        <Tooltip target=".export-buttons>button" position="bottom"/>

                                        <DataTable value={data}
                                                   responsiveLayout="scroll"
                                                   dataKey="id"
                                                   header={header}
                                                   paginator
                                                   paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                                   rowsPerPageOptions={[10, 25, 50]}
                                                   currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                                   rows={10}
                                                   sortMode="multiple" filters={filters} filterDisplay="menu"
                                                   resizableColumns
                                                   ref={dt}
                                                   scrollable scrollHeight="720px"
                                                   selection={selectedData}
                                                   onSelectionChange={onSelectionChange}
                                                   selectionMode="checkbox"
                                        >
                                            <Column selectionMode="multiple"/>
                                            <Column field="id" header="Id" sortable/>
                                            <Column field="title" header="Title"/>
                                            <Column field="first_name" header="Name"/>
                                            <Column field="last_name" header="Last Name"/>
                                            <Column field="id_number" header="Id Number"/>
                                            <Column field="date_of_birth" header="D O B"/>
                                            <Column field="gender" header="Gender"/>
                                            <Column field="status" header="Status"/>
                                            <Column field="occupation" header="Occupation"/>
                                            <Column field="salary" header="Salary"/>
                                            <Column field="ec_number" header="EC Number"/>
                                            <Column field="mobile" header="Mobile"/>
                                            <Column field="smoker_status" header="Smoker Status"/>
                                            <Column field="created_at" header="Joined"/>
                                        </DataTable>
                                        <div className="row mt-2">
                                            {policies && (
                                                <div className="col-lg-6 col-md-6 col-sm-12">
                                                    <PoliciesPartial policies={policies}/>
                                                </div>
                                            )}
                                            <div className="col-lg-6 col-md-6 col-sm-12">
                                                <DependentsPartial dependents={dependents}/>
                                            </div>
                                        </div>
                                    </div>
                                    {/*    end tabs*/}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    )

}

export default PolicyHoldersReport
